import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';
import {isFirstLoad} from 'nutshell-core/utils/graphql-loading';

import type {
    FormForLandingPage as Form,
    GetFormsForLandingPages as GetFormsForLandingPagesQuery,
    GetFormsForLandingPagesVariables as GetFormsForLandingPagesQueryVariables,
} from 'nutshell-graphql-types';

import GET_FORMS_FOR_LANDING_PAGES from '../queries/get-forms-for-landing-pages.graphql';

export function useGetFormsForLandingPages(search: string): {
    forms: Form[];
    isLoading: boolean;
    isFirstLoad: boolean;
    error: string | null | undefined;
} {
    const {data, error, loading, networkStatus} = useQuery<
        GetFormsForLandingPagesQuery,
        GetFormsForLandingPagesQueryVariables
    >(GET_FORMS_FOR_LANDING_PAGES, {
        variables: {
            search,
            sort: 'NAME_ASC',
        },
        fetchPolicy: 'cache-and-network',
    });

    return {
        forms: (data && data.forms && data.forms.edges.map((edge) => edge && edge.node)) || [],
        isLoading: loading,
        isFirstLoad: isFirstLoad(networkStatus),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
}
